import { useLayoutEffect, useState } from 'react';
import { mobileWidth } from '../const/size.const';
import setFontSizes from '../utils/fontSizeSetter';

const useShowMobileVersion = () => {
  const [show, setShow] = useState(false);
  const [initialCheck, setInitialCheck] = useState(false);

  useLayoutEffect(() => {
    function updateSize() {
      setShow(window.innerWidth < mobileWidth);
      setFontSizes(window.innerWidth < mobileWidth ? 'mobile' : 'desktop');
    }

    window.addEventListener('resize', updateSize);
    updateSize();
    setInitialCheck(true);

    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  return { show, initialCheck };
};

export default useShowMobileVersion;
